<quick-ticket-launcher
    *ngIf="isLoggedOn"
    [attr.ticker]="fundInput.ticker"
    mode="button"
    transactionType="BUY"
    [launcherButtonConfig]="launcherConfig"
    (stateChange)="onStateChange($event)"
    (click)="handleQuickTicketClickEvent()"
></quick-ticket-launcher>
<c11n-button
    *ngIf="!isLoggedOn"
    [buttonType]="'button'"
    [id]="'buy-btn'"
    [size]="size"
    [variant]="'primary'"
    [labelText]="'Buy'"
    [ariaLabelText]="'Buy ' + fundInput.fundName"
    (clickEvent)="buyFunds()"
></c11n-button>
